module.exports = __webpack_public_path__ + "img/bird-12-left.17d89e9e.png";